import { useMutation } from '@apollo/client';
import type { UpdateCustomerGroup, UpdateCustomerGroupInput, UpdateCustomerGroupVariables } from 'types/graphql';
import { CUSTOMER_GROUP_PAGE_QUERY } from './useCustomerGroups';

const UPDATE_CUSTOMER_GROUPS = gql`
  mutation UpdateCustomerGroup($id: Int!, $input: UpdateCustomerGroupInput!) {
    updateCustomerGroup(id: $id, input: $input) {
      id
    }
  }
`;

export default function useUpdateCustomerGroup() {
  const [updateCustomerGroup] = useMutation<UpdateCustomerGroup, UpdateCustomerGroupVariables>(UPDATE_CUSTOMER_GROUPS, {
    refetchQueries: [CUSTOMER_GROUP_PAGE_QUERY],
  });
  return async (id: number, input: UpdateCustomerGroupInput) => {
    const res = await updateCustomerGroup({ variables: { id, input } });
    return res.data?.updateCustomerGroup?.id as number;
  };
}
